import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import SetupStep1 from './SetupStep1';
import SetupStep2 from './SetupStep2';
import SetupStep3 from './SetupStep3';
import SetupStep4 from './SetupStep4';
import SetupStep5 from './SetupStep5';

import { 
    ASSESSMENT_PERIOD, 
    SETUP_MAPPING_VALIDATION_ERROR_1,
    SETUP_MAPPING_VALIDATION_ERROR_2
} from '../../../fastConstants';

const STEPS = ["One", "Two", "Three", "Four"]
const THEMES = {
    1: "Thinking in Action",
    2: "Practicing Community",
    3: "Professional Skills"
}

const FAST_URL = process.env.REACT_APP_DS_API_URL
const BASE_URL = FAST_URL + "/setup/"
const MODE = "modify"
const LOG_URL = false
const LOG_PAYLOAD = false
const LOG_RESPONSE = false

export default function SetupModifyForm(props) {
    const [setup, setSetup] = useState({})
    const { setupId } = useParams('setupId')
    const [currentStep, setCurrentStep] = useState(1)
    const currentUser = props.username
    const [programId, setProgramId] = useState();
    const [activePrograms, setActivePrograms] = useState({})
    const [submittedPrograms, setSubmittedPrograms] = useState({})
    const [submittedUsers, setSubmittedUsers] = useState({})
    const [submittedDates, setSubmittedDates] = useState({})
    const [submittedMappings, setSubmittedMappings] = useState({})
    const [learningOutcomeMappings, setLearningOutcomeMappings] = useState({})
    const [errorFound, setErrorFound] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [departmentId, setDepartmentId] = useState(null)
    const [departments, setDepartments] = useState(null)
    const [department, setDepartment] = useState(null)
    const [programLearningOutcomes, setProgramLearningOutcomes] = useState({})
    const [programAssessmentsCreated, setProgramAssessmentsCreated] = useState({})
    
    useMemo(() => {
        if (setupId) {
            let url = BASE_URL + setupId
            if (LOG_URL) console.log(url)
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                setSetup(data) 
                setDepartment(data.department)
                setDepartmentId(data.department.departmentId)
            })
            .catch(err => console.log(err))
        }
    }, [setupId])
    useMemo(() => {
        let url = FAST_URL + "/department"
        if (LOG_URL) console.log(url)
        fetch(url)
        .then(response => {
            return response.json()
        })
        .then(data => {
            setDepartments(data)
        })
        .catch(err => {
            console.log(err)
        })
    },[])
    useMemo(() => {
        if (department) {
            let url = FAST_URL + "/learning-outcome/active/" + department.departmentId
            if (LOG_URL) console.log(url)
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                let currentSlos = {...programLearningOutcomes}
                currentSlos[department.departmentId] = data
                setProgramLearningOutcomes({...currentSlos})
            })
            .catch(err => {
                console.log(err)
            })
        }
    }, [department, programLearningOutcomes])

    useMemo(() => {
        if (department) {
            let url = FAST_URL + "/assessments?departmentId=" + department.departmentId + "&reviewYear=" + ASSESSMENT_PERIOD
            if (LOG_URL) console.log(url)
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.submittedPrograms) {
                    let programAssessments = {}
                    data.submittedPrograms.forEach((program) => {
                        if (program.status === "completed" || program.status === "in-progress") {
                            programAssessments[program.programId] = true
                        }
                    })
                    setProgramAssessmentsCreated(programAssessments)
                }
            })
            .catch(err => {
                console.log(err)
            })
        }
    }, [department])

    useMemo(() => {
        if (setup.mappings) {
            let newActivePrograms = {};
            Object.keys(setup.mappings).forEach(k => {
                newActivePrograms[k] = 'yes'
            })
            
            //setActivePrograms({...newActivePrograms})

            let newLearningOutcomeMappings = {}
            let newSubmittedPrograms = {}
            let newSubmittedUsers = {}
            let newSubmittedDates = {}
            let newSubmittedMappings = {}
            
            for (const [k,v] of Object.entries(setup.mappings)) {
                let key = 'program-' + k
                v.forEach((mapping) => {
                    let firstThemeKey = key + '_slo-' + (mapping.sloId) + '_theme-1'
                    newLearningOutcomeMappings[firstThemeKey] = mapping.firstThemeAnswer
                    let secondThemeKey = key + '_slo-' + (mapping.sloId) + '_theme-2'
                    newLearningOutcomeMappings[secondThemeKey] = mapping.secondThemeAnswer
                    let thirdThemeKey = key + '_slo-' + (mapping.sloId) + '_theme-3'
                    newLearningOutcomeMappings[thirdThemeKey] = mapping.thirdThemeAnswer

                    if (mapping.submittedBy) {
                        newSubmittedPrograms[k] = 'yes'
                        newSubmittedUsers[k] = mapping.submittedBy
                        newSubmittedDates[k] = mapping.dateSubmitted
                        
                    }

                    if (mapping.mappingId) {
                        newSubmittedMappings[mapping.sloId] = mapping.mappingId
                    }
                })
            }
            
            setLearningOutcomeMappings({...newLearningOutcomeMappings})
            setSubmittedPrograms({...newSubmittedPrograms})
            setSubmittedUsers({...newSubmittedUsers})
            setSubmittedDates({...newSubmittedDates})
            setSubmittedMappings({...newSubmittedMappings})
        }
    }, [setup])
    const getProgramLearningOutcomes = (departmentId, programId) => {
        let departmentSlos = programLearningOutcomes[departmentId].learningOutcomes
        return departmentSlos[programId]
    }
    const handleNext = () => {
        // Clear the error message first
        setErrorFound(false)
        setErrorMessage('')

        let canContinue = true;
        switch (currentStep) {
            case 1:
                canContinue = validateStepOne()
                break
            case 2:
                canContinue = validateStepTwo()
                break
            case 3:
                canContinue = validateStepThree()
                break
            case 4:
                canContinue = submitSetup()
                break
            default:
                console.log('Unknown step - ' + currentStep)
        }
        if (canContinue) {
            setCurrentStep(prevStep => prevStep + 1)
        }
    }
    const handleBack = () => {
        if (currentStep > 0) {
            setCurrentStep(prevStep => prevStep - 1)
        }
    }
    const validateStepOne = () => {
        let valid = false
        for (const value of Object.values(activePrograms)) {
            if (value === 'yes') {
                valid = true
                break
            }
        }
        return valid
    }
    const createKey = (programId, sloId, themeId) => {
        return 'program-' + programId + '_slo-' + sloId + '_theme-' + themeId
    }
    const verifyLearningOutcomesAreMapped = () => {
        const programIds = []
        for (const [key,value] of Object.entries(activePrograms)) {
            let k = parseInt(key)
            if (!programIds.includes(k) && value === 'yes') {
                programIds.push(k)
            }
        }
        
        var allThemesMapped = true

        for (let i = 0; i < programIds.length; i++) {
            let departmentSlos = programLearningOutcomes[department.departmentId].learningOutcomes
            
            // verify that each learning outcome is mapped to at least one theme
            departmentSlos[programIds[i]].forEach(function(slo) {
                let theme1 = createKey(programIds[i], slo.sloId, 1)
                let theme2 = createKey(programIds[i], slo.sloId, 2)
                let theme3 = createKey(programIds[i], slo.sloId, 3)

                var sloMappedToTheme1 = false
                var sloMappedToTheme2 = false
                var sloMappedToTheme3 = false

                if (theme1 in learningOutcomeMappings && learningOutcomeMappings[theme1] === 'yes') {
                    sloMappedToTheme1 = true
                }
                
                if (theme2 in learningOutcomeMappings && learningOutcomeMappings[theme2] === 'yes') {
                    sloMappedToTheme2 = true
                } 
                
                if (theme3 in learningOutcomeMappings && learningOutcomeMappings[theme3] === 'yes') {
                    sloMappedToTheme3 = true
                }

                // If we find at least one learning outcome NOT mapped to a theme, 
                // the whole verification fails.
                if (sloMappedToTheme1 === false &&  sloMappedToTheme2 === false && sloMappedToTheme3 === false) {
                    allThemesMapped = false
                }
            })
        }
        return allThemesMapped
    }
    const validateMapping = () => {
        const programIds = []
        for (const key of Object.keys(activePrograms)) {
            let k = parseInt(key)
            if (!programIds.includes(k)) {
                programIds.push(k)
            }
        }

        // Check that at least one "yes" is found in each row per program
        for (let pid = 0; pid < programIds.length; pid++) {
            let programId = programIds[pid]
            let obj = getProgramLearningOutcomes(department.departmentId, programId)
            

            for (const value of Object.values(obj)) {
                let sloArray = []

                let sloKey1 = createKey(programId, value.sloId, 1)
                let sloKey2 = createKey(programId, value.sloId, 2)
                let sloKey3 = createKey(programId, value.sloId, 3)

                sloArray.push(learningOutcomeMappings[sloKey1])
                sloArray.push(learningOutcomeMappings[sloKey2])
                sloArray.push(learningOutcomeMappings[sloKey3])

                if (!sloArray.includes('yes')) {
                    console.log('false')
                    return false
                }

                sloArray = []
            }
        }

        // Check that at least one "yes" is found in each col per program learning outcome
        for (let pid = 0; pid < programIds.length; pid++) {
            let programId = programIds[pid]
            let obj = getProgramLearningOutcomes(department.departmentId, programId)
            let sloMap = {}
            sloMap['theme-1'] = []
            sloMap['theme-2'] = []
            sloMap['theme-3'] = []

            // sloMap['theme-1'] = ['no', 'yes', 'no'] -- ok
            // sloMap['theme-2'] = ['no', 'no', 'no'] -- err

            for (const k of Object.keys(sloMap)) {
                for (const value of Object.values(obj)) {
                    let sloKey = 'program-' + (programId) + '_slo-' + (value.sloId) + '_' + k
                    sloMap[k].push(learningOutcomeMappings[sloKey])
                }
                
                if (!sloMap[k].includes('yes')) {
                    return false
                }
            }
        }

        return true
    }
    const validateStepTwo = () => {
        if (!verifyLearningOutcomesAreMapped()) {
            setErrorFound(true)
            setErrorMessage(SETUP_MAPPING_VALIDATION_ERROR_1)
            return false
        } else if (!validateMapping()) {
            setErrorFound(true)
            setErrorMessage(SETUP_MAPPING_VALIDATION_ERROR_2)
            return false
        } else {
            setErrorFound(false)
            setErrorMessage('')
            return true
        }
    }
    const validateStepThree = () => {
        return true
    }
    const validateNextStep = () => {
        let isValid = false
        if (activePrograms) {
            for (const value of Object.values(activePrograms)) {
                if (value === 'yes') {
                    isValid = true
                    break
                }
            }
        }
        return isValid
    }
    const onThemeChanged = (event) => {
        let progId = event.target.name
        let newPrograms = {...activePrograms}

        if (event.target.value === "yes") {
            newPrograms[progId] = event.target.value
        } else if (event.target.value === "no") {
            newPrograms[progId] = event.target.value
        } else {
            if (newPrograms.hasOwnProperty(progId)) {
                let newSubmittedPrograms = {...submittedPrograms}
                let newSubmittedUsers = {...submittedUsers}
                let newSubmittedDates = {...submittedDates}
                
                delete newSubmittedPrograms[progId]
                delete newSubmittedUsers[progId]
                delete newSubmittedDates[progId]
                delete newPrograms[progId]

                setSubmittedPrograms({...newSubmittedPrograms})
                setSubmittedUsers({...newSubmittedUsers})
                setSubmittedDates({...newSubmittedDates})

                let newLearningOutcomeMappings = {...learningOutcomeMappings}
                for (const key of Object.keys(newLearningOutcomeMappings)) {
                    let tmpKey = 'program-' + progId
                    if (key.includes(tmpKey)) {
                        delete newLearningOutcomeMappings[key]
                    }
                }
                setLearningOutcomeMappings({...newLearningOutcomeMappings})
            }
        }

        setActivePrograms({...newPrograms})
    }

    const onSetupSubmitChanged = (event) => {
        let newSubmittedPrograms = {...submittedPrograms}
        let newSubmittedUsers = {...submittedUsers}
        let newSubmittedDates = {...submittedDates}

        if (event.target.value === "yes") {
            const dt = new Date()
            newSubmittedPrograms[event.target.name] = event.target.value
            newSubmittedUsers[event.target.name] = currentUser
            newSubmittedDates[event.target.name] = dt.toISOString()
        } else if (event.target.value === "no") {
            newSubmittedPrograms[event.target.name] = event.target.value
            delete newSubmittedUsers[event.target.name]
        } else {
            if (newSubmittedPrograms.hasOwnProperty(event.target.name)) {
                delete newSubmittedPrograms[event.target.name]
                delete newSubmittedUsers[event.target.name]
                delete newSubmittedDates[event.target.name]
            }
        }

        setSubmittedPrograms({...newSubmittedPrograms})
        setSubmittedUsers({...newSubmittedUsers})
        setSubmittedDates({...newSubmittedDates})
    }

    const onLearningOutcomeChanged = (event) => {
        if (event.target.value === '') {
            const newLearningOutcomeMappings = {...learningOutcomeMappings}
            delete newLearningOutcomeMappings[event.target.name]
            setLearningOutcomeMappings({...newLearningOutcomeMappings})
        } else {
            const newLearningOutcomeMappings = {...learningOutcomeMappings, [event.target.name] : event.target.value}
            setLearningOutcomeMappings({...newLearningOutcomeMappings})
        }
    }
    const newAuditInfo = () => {
        const dt = new Date()
        return {
            createdBy: currentUser,
            dateCreated: dt.toISOString(),
            modifiedBy: currentUser,
            dateModified: dt.toISOString()
        }
    }
    const transformMappings = () => {
        // Program ID => Map of Mappings
        let programMappings = {}
        
        for (const [key,value] of Object.entries(learningOutcomeMappings)) {
            // key = 'program-X_slo-Y_theme-Z
            let tokens = key.split('_')
            let programId = parseInt(tokens[0].split('-')[1])
            let learningOutcomeId = tokens[1].split('-')[1]
            
            if (!(programId in programMappings)) {
                programMappings[programId] = {}
            }
            
            let mappings = programMappings[programId]
            let newKey = tokens[0] + '_' + tokens[1]
            if (!(newKey in mappings)) {
                let mapping = {
                    department: {
                        departmentId: setup.department.departmentId,
                    },
                    program: programId,
                    reviewYear: ASSESSMENT_PERIOD,
                    learningOutcome: parseInt(learningOutcomeId),
                    auditInfo: newAuditInfo(),
                }

                if (learningOutcomeId in submittedMappings) {
                    mapping['mappingId'] = submittedMappings[learningOutcomeId]
                }

                if (programId in submittedPrograms) {
                    mapping['submittedBy'] = submittedUsers[programId]
                    mapping['dateSubmitted'] = submittedDates[programId]
                }

                mappings[newKey] = mapping
            }

            let mapping = mappings[newKey]

            if (key.endsWith('theme-1')) {
                mapping.firstTheme = THEMES[1]
                mapping.firstThemeAnswer = value
            } else if (key.endsWith('theme-2')) {
                mapping.secondTheme = THEMES[2]
                mapping.secondThemeAnswer = value
            } else if (key.endsWith('theme-3')) {
                mapping.thirdTheme = THEMES[3]
                mapping.thirdThemeAnswer = value
            }
        }

        let newMappings = {}
        for (const key of Object.keys(programMappings)) {
            if (!(key in newMappings)) {
                newMappings[key] = []
            }
            for (const value of Object.values(programMappings[key])) {
                newMappings[key].push(value)
            }
        }
        return newMappings
    }
    const submitSetup = () => {
        let url = process.env.REACT_APP_DS_API_URL + "/setup/" + setup.setupId
        let departmentSetup = {
            setupId: setup.setupId,
            department: {
                departmentId: setup.department.departmentId,
            },
            reviewYear: ASSESSMENT_PERIOD,
            mappings: transformMappings(),
            auditInfo: newAuditInfo(),
        }

        if (LOG_PAYLOAD) console.log(departmentSetup)

        fetch(url,
        {
            body: JSON.stringify(departmentSetup),
            method: "put",
            headers: {'Content-Type': 'application/json'},
        })
        .then(response => {
            if (LOG_RESPONSE) console.log(response)
        })
        .catch(err => {
            console.log(err)
        })

        return true
    }

    let step;
    if (currentStep === 1) {
        step = <SetupStep1 
                    mode={MODE}
                    department={department}
                    departments={departments}
                    onThemeChanged={onThemeChanged}
                    activePrograms={activePrograms}
                    setup={setup}
                    programAssessmentsCreated={programAssessmentsCreated}
                    departmentLearningOutcomes={programLearningOutcomes}
                    />
    } else if (currentStep === 2) {
        step = <SetupStep2 
                    mode={MODE}
                    departmentId={department.departmentId}
                    department={department}
                    departments={departments}
                    programId={programId}
                    onProgramSelect={e => setProgramId(e.target.value)}
                    programLearningOutcomes={programLearningOutcomes[departmentId].learningOutcomes}
                    activePrograms={activePrograms}
                    onLearningOutcomeChanged={onLearningOutcomeChanged}
                    learningOutcomeMappings={learningOutcomeMappings}
                    setup={setup}
                    />
    } else if (currentStep === 3) {
        step = <SetupStep3 
                    mode={MODE}
                    currentUser={currentUser}
                    departmentId={setup.department.departmentId}
                    department={setup.department}
                    departments={departments}
                    programId={programId}
                    activePrograms={activePrograms}
                    programLearningOutcomes={programLearningOutcomes[departmentId].learningOutcomes}
                    learningOutcomeMappings={learningOutcomeMappings}
                    submittedPrograms={submittedPrograms}
                    onSetupSubmitChanged={onSetupSubmitChanged}
                    setup={setup}
                    />
    } else if (currentStep === 4) {
        step = <SetupStep4 
                    mode={MODE}
                    departmentId={setup.department.departmentId}
                    department={setup.department}
                    departments={departments}
                    activePrograms={activePrograms}
                    programLearningOutcomes={programLearningOutcomes[departmentId].learningOutcomes}
                    learningOutcomeMappings={learningOutcomeMappings}
                    submittedPrograms={submittedPrograms}
                    submittedUsers={submittedUsers}
                    />
    } else if (currentStep === 5) {
        step = <SetupStep5 
                    />
    } else {
        step = null
    }
    return (
        <React.Fragment>
            <form>
                {step}
                <div className="py-3 mx-auto text-center">
                    {errorFound &&
                        <div style={{color: "red"}}>
                            {errorMessage}
                        </div>
                    }
                </div>
                { currentStep < 5 &&
                    <div className="form-button-group text-center">
                        <span className="col-md-6 px-1">
                            <Button
                                onClick={handleBack}
                                disabled={currentStep <= 1}
                                >
                                Back
                            </Button>
                        </span>
                        <span className="col-md-6 px-1">
                            <Button
                                onClick={handleNext}
                                disabled={!validateNextStep()}
                                >
                                {currentStep < (STEPS.length) ? 'Next' : 'Save'}
                            </Button>
                        </span>
                    </div>
                    
                }
            </form>
        </React.Fragment>
    )
}
